import { SharedState } from '@trello/shared-state';

export const ClickToCreateAccountIdState = new SharedState<string>('');
